export default __webpack_public_path__ + "static/media/e-filing-logotype-l.a57c9aea.svg";